// extracted by mini-css-extract-plugin
export default {"InputSearch_Container":"InputSearch_Container_flAPm_v17-8-1","InputSearch_Icon":"InputSearch_Icon_YbV9o_v17-8-1","InputSearch":"InputSearch_TaS5p_v17-8-1"};